module.exports = __webpack_public_path__ + "img/logo_ecopetrol.a6db80dc.png";